/*
 * @Author: your name
 * @Date: 2021-11-05 15:08:58
 * @LastEditTime: 2021-11-08 13:29:41
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /burgeon-project-logic/src/config/minxin/standardTableListsCustomize.js
 */
import listJsActions from './listJsActions';
import configModule from '@/config/config';
import { standMarkMixin } from './mixinForWatermark';

const downloadUrlFile = (src) => {
  let reUrl = /(http|https):\/\/([\w.]+\/?)\S*/;
  if (reUrl.test(src) === false) {
    throw new Error('code为0或1，部分成功部分失败，请返回以 http 或者 https 开头的错误信息下载链接！');
  }
  src = src.replace(/^(http|https):/, window.location.protocol)
  const download_file = {};
  if (typeof download_file.iframe === 'undefined') {
    const iframe = document.createElement('iframe');
    download_file.iframe = iframe;
    document.body.appendChild(download_file.iframe);
  }
  download_file.iframe.src = src;
  download_file.iframe.style.display = 'none';
};

export default () => ({
  mixins: [listJsActions(), standMarkMixin()],
  data() {
    return {
      tableName: this.$route.params.tableName,
    };
  },
  watch: {
    // 全部Tab 隐藏按钮
    currentTabIndex: {
      handler(val) {
        const cb = (showBtns) => {
          document.querySelectorAll('.StandardTableListRootDiv .R3-button-group button').forEach(element => {
            if (val == 0) {
              element.style.display = !showBtns.includes(element.getAttribute('id')) && !element.classList.contains('collection') ? 'none' : 'inline'
            } else {
              element.style.display = ['reset', 'refresh'].includes(element.getAttribute('id')) ? 'none' : 'inline'
            }
          })
        }
        switch (this.tableName) {
          case 'OLD_MALL_AFTER_SALE_MANAGER': // 老商城-售后处理
          case 'OC_B_AFTER_SALE_MANAGE': // 售后处理
            cb(['actionEXPORT'])
            break;
          default:
            break;
        }
      },
      immediate: true
    }
  },
  computed: {
    // 当前tab索引（多tab页）
    currentTabIndex() {
      const page = vm.$_live_getChildComponent(vm, R3.getModuleName())
      return page && page.currentTabValue && page.currentTabValue.index
    }
  },
  created() {
    // 标准界面-查询添加入参
    let getQueryListPromise = this.getQueryListPromise;
    this.getQueryListPromise = function (data) {
      this.addReturnOrderWarningParams(data);
      getQueryListPromise.call(this, ...arguments);
    };
    if (this.tableName == 'INVENTORY_MODEL_QUERY') {
      localStorage.removeItem('INVENTORY_MODEL_QUERY_mounted_count')
      localStorage.removeItem(`${this.tableName}_modal_data`)
    }
  },
  updated() {
    this.$nextTick(() => {
      configModule.cssHandle.legendNodeHandle(); // 列表页面-表格/图例 样式
      configModule.cssHandle.btnText(); // 按钮文案调整
    });
  },
  mounted() {},
  methods: {
    R3_searchDataMinx(data) {
      if (['V_RPT_SG_B_STORAGE', 'V_RPT_SG_B_SHARE_STORAGE', 'V_SG_B_SA_STORAGE'].includes(data.table)) {
        if (data.fixedcolumns) {
          for (const key in data.fixedcolumns) {
            if (data.fixedcolumns[key] && typeof data.fixedcolumns[key] == 'string') {
              data.fixedcolumns[key] = data.fixedcolumns[key].replaceAll(' ', ',')
            }
          }
        }
      }
      return data
    },
    // 立即分货
    async EXECUTE_DISTRIBUTION(action, row) {
      const { tableName } = this.$route.params;
      const agRows = vm.$store.state[R3.getModuleName()].ag.datas.row
      if (!row && !agRows.length) {
        return $fcWarn({
          content: t('当前无数据，请查询后操作'),
          showCancel: true,
          onOk: () => {}
        });
      }
      let cb = () => {
        let params = {}
        switch (tableName) {
          case 'SG_B_STO_TRANSFER_IN_DISTRIBUTION':
            const fn = (row) => {
              return {
                ID: row.ID.val,
                SG_C_SHARE_STORE_ID: row.SG_C_SHARE_STORE_ID ? row.SG_C_SHARE_STORE_ID.refobjid : '',
                SKU_CATEGORY_ID: row.PS_C_SKU_ID ? row.PS_C_SKU_ID.refobjid : '',
                STRATEGY_ID: row.SG_C_PERCENT_STRATEGY_ID ? row.SG_C_PERCENT_STRATEGY_ID.refobjid : '',
                QTY: row.QTY.val,
              }
            }
            params = {
              fixedcolumns: {
                STRATEGY_TYPE: '4',
                VALUE: row ? [fn(row)] : agRows.map(fn)
              }
            }
            break;
          default:
            break;
        }
        const formData = new FormData()
        formData.append('searchdata', JSON.stringify(params))
        const loadingName = this.$route.meta.moduleName.replace(/\./g, '-');
        this.$R3loading.show(loadingName);
        this.service.common.publicUrlParams('/api/cs/sg/v1/percent/distribution/execute', formData).then(res => {
          if (res.data.code == 0) {
            this.$Message.success(res.data.message)
            $('#search')[0].click()
          }
        }).finally(() => this.$R3loading.hide(loadingName))
      }
      $fcWarn({
        content: t('确认执行【{}】操作吗？', action.webdesc),
        showCancel: true,
        onOk: () => {
          cb()
        }
      });
    },
    R3_openedApi_export(event) {
      // 这里event必须传
      // 标准列表导出前校验
      const { tableName } = this.$route.params;
      const tableArr = ['SG_B_STO_OTHER_OUT_RESULT'];
      if (tableArr.includes(tableName)) {
        const params = new FormData();
        params.append('menu', tableName);
        params.append('taskType', event.name);
        this.service.common.exportTaskCheck(params).then((res) => {
          if (res.data.code == 0) {
            this.batchExport(event); // 调用框架导出
          }
        });
      } else {
        this.batchExport(event); // 调用框架导出
      }
    },
    EXPRESS_COST_EXPORT(action) {
      this.actionExport({ ...action, api: 'exportExpressCost' });
    },
    EXPRESS_PRICE_EXPORT(action) {
      this.actionExport({ ...action, api: 'exportExpressPrice' });
    },
    CP_C_PAYWAY_EXPORT(action) {
      this.actionExport({ ...action, api: 'exportsMainDetail' });
    },
    UNFULLCAR_COST_EXPORT(action) {
      this.actionExport({ ...action, api: 'exportSyncUnfullcarCost' });
    },
    EXPORT_SKU_GROUP(action) {
      // 组合商品导出
      this.actionExport({ ...action, api: 'exportSkuGroup', center: 'commodityCenter' });
    },
    OC_B_2_B_ORDER_JX_EXPORT(action) {
      this.actionExport({ ...action, api: 'exportOcB2BOrder', center: 'orderCenter' });
    },
    OC_B_2_B_ORDER_FX_EXPORT(action) {
      this.actionExport({ ...action, api: 'exportOcB2BOrder', center: 'orderCenter' });
    },
    OC_B_2_B_ORDER_DX_EXPORT(action) {
      this.actionExport({ ...action, api: 'exportOcB2BOrder', center: 'orderCenter' });
    },
    SG_B_DISTRIBUTION_RETURN_DIS_EXPORT(action) {
      this.actionExport({ ...action, api: 'exportDistribution', center: 'orderCenter' });
    },
    SG_B_DISTRIBUTION_RETURN_SELL_EXPORT(action) {
      this.actionExport({ ...action, api: 'exportDistribution', center: 'orderCenter' });
    },
    SG_B_DISTRIBUTION_RETURN_CONS_EXPORT(action) {
      this.actionExport({ ...action, api: 'exportDistribution', center: 'orderCenter' });
    },
    SG_B_DISTRIBUTION_RETURN_ONE_DIS_EXPORT(action) {
      this.actionExport({ ...action, api: 'exportDistribution', center: 'orderCenter' });
    },
    SG_B_DISTRIBUTION_ORDER_EXPORT(action) {
      this.actionExport({ ...action, api: 'exportDistributionOrder', center: 'orderCenter' });
    },
    // 唯品会入库单
    OC_B_VIPCOM_DELIVERY_EXPORT(action) {
      this.actionExport({ ...action, api: 'exportVipOrder', center: 'orderCenter' });
    },
    // JIT配货单
    OC_B_VIPCOM_DISTRIBUTION_EXPORT(action) {
      this.actionExport({ ...action, api: 'exportV2', center: 'orderCenter' });
    },

    actionExport(action) {
      let tableArr = [
        'ST_C_EXPRESS_PRICE_STRATEGY', 'ST_C_UNFULLCAR_COST', 'ST_C_EXPRESS_COST', 'PS_C_PRO_GROUP',
        'SG_B_DISTRIBUTION_ORDER', 'OC_B_VIPCOM_DELIVERY', 'OC_B_VIPCOM_DISTRIBUTION'
      ];
      let addSearchParams = [
        'CP_C_PAYWAY',
        'SG_B_DISTRIBUTION_ORDER', 'OC_B_VIPCOM_DELIVERY', 'OC_B_VIPCOM_DISTRIBUTION'
      ];
      const asyncArr = [
        'OC_B_2_B_ORDER_JX', 'OC_B_2_B_ORDER_FX', 'OC_B_2_B_ORDER_DX', 'OC_B_VIPCOM_DELIVERY',
        'SG_B_DISTRIBUTION_ORDER', 'SG_B_DISTRIBUTION_RETURN_DIS', 'SG_B_DISTRIBUTION_RETURN_SELL',
        'SG_B_DISTRIBUTION_RETURN_CONS', 'SG_B_DISTRIBUTION_RETURN_ONE_DIS', 'OC_B_VIPCOM_DISTRIBUTION'
      ];
      tableArr = tableArr.concat(asyncArr).concat(addSearchParams);
      if (tableArr.includes(this.tableName)) {
        const IDS = this.idArray || [];
        const formdata = new FormData();
        if (asyncArr.includes(this.tableName)) {
          formdata.append('type', this.tableName.replace(/.*(RETURN|ORDER)_/, ''));
        }
        // TODO: 待优化，将不同处理逻辑抽离出来
        if (addSearchParams.includes(this.tableName)) {
          const _copySearchData = JSON.parse(JSON.stringify(this.searchData));
          if (!_copySearchData.fixedcolumns) _copySearchData.fixedcolumns = {};
          if(IDS && IDS.length)
          _copySearchData.fixedcolumns.ID = IDS.join();
          formdata.append('searchdata', JSON.stringify(_copySearchData));
          if (this.tableName === 'OC_B_VIPCOM_DISTRIBUTION') {
            formdata.append('filename', 'JIT配货单');
            formdata.append('filetype', '.xlsx');
            formdata.append('isExportChild', 'true');
            formdata.append('exportMode', 'APPEND');
            formdata.append('childInfo', JSON.stringify([{ table: 'OC_B_VIPCOM_DISTRIBUTION_ITEM', selectionFields: '' }]));
            formdata.append('menu', 'JIT配货单');
            formdata.append('showColumnName', 'true');
          }
        } else {
          formdata.append('ids', IDS.join());
        }
        const center = action.center || 'strategyPlatform';
        this.service[center][action.api](formdata).then((res) => {
          if (res.data.code == 0) {
            const data = res.data.data;
            if (asyncArr.includes(this.tableName)) {
              return window.dispatchEvent(
                new CustomEvent('addTask', {
                  detail: {
                    type: 'notice',
                  },
                })
              );
            }
            if (data !== null) {
              downloadUrlFile(data);
            }
          } else {
            const err = res.data.message || t('失败！');
            $fcError(err);
          }
        });
      }
    },
    columnRenderer(cellData, render) {
      if (vm.$route.fullPath.includes('/SYSTEM/TABLE/')) {
        if (this.tableName == 'OLD_MALL_AFTER_SALE_MANAGER') {
          if (['AFTER_SALE_TYPE', 'GOODS_STATUS'].includes(cellData.colname)) {
            const flag = [2, 0].some(dex => $('.StandardTableListRootDiv .r3-tab-nav')[0].__vue__.currentIndex == dex) // 全部 ｜ 退货退款（签收前）
            render.renderContainer = 'CellRenderByFunction';
            render.renderComponent = (h, params) => {
              const val = params.row[cellData.colname].val
              return h('div', [
                h('span', {}, val),
                flag ? h('i', {
                  class: 'iconfont icon icon-Edit',
                  style: {
                    fontSize: '12px',
                    color: '#0068b7',
                    cursor: 'pointer',
                    'padding-left': '6px'
                  },
                  on: {
                    click: (e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      vm.$store.commit("omsStore/up_listCCData", {
                        falg: new Date(),
                        row: {...params.row},
                        tabth: [...params.options.datas.tabth]
                      });
                      Vue.component('UP_OLD_MALL', () => import('@/config/minxin/standardTable/list/UP_OLD_MALL.vue'));
                      vm.$store.commit("omsStore/up_listOtherComponent", 'UP_OLD_MALL');
                    },
                  },
                }) : []
              ]);
            }
          }
        }
        if (this.tableName == 'SG_B_SA_STORAGE') {
          // 配销仓库存 - 库存调整
          const btns = this.$children[0].$children[0].dataArray.waListButtonsConfig.waListButtons
          const btn = btns.find(i => i.webname == 'SG_B_SA_STORAGE_ADJUST')
          if (!btn) {
            return
          }
          if (cellData.colname === 'ADJUST_STORAGE') {
            render.renderContainer = 'CellRenderByFunction';
            render.renderComponent = (h, params) => {
              let adjust_num = ''
              return h('div', {}, [
                h('input', {
                  class: 'ark-input ark-input-default',
                  style: {
                    width: 'calc(100% - 35px)',
                    height: '21px'
                  },
                  domProps: {
                    value: adjust_num
                  },
                  on: {
                    blur: event => {
                      adjust_num = event.target.value == '' || Number.isNaN(event.target.value) ? '' : Number(event.target.value);
                    },
                    keyup: event => {
                      // 非0的正负整数
                      const num1 = event.target.value.charAt(0)
                      if (['-', '+'].includes(num1)) {
                        let num2 = ''
                        if (event.target.value.substring(1).charAt(0) == 0) {
                          num2 = event.target.value.substring(2).replace(/[^\d]/g, ''); // 清除“数字”以外的字符
                        } else {
                          num2 = event.target.value.substring(1).replace(/[^\d]/g, ''); // 清除“数字”以外的字符
                        }
                        event.target.value = `${num1}${num2}`
                      } else {
                        if (num1 == 0) {
                          event.target.value = event.target.value.substring(1).replace(/[^\d]/g, '')
                        } else {
                          event.target.value = event.target.value.replace(/[^\d]/g, '')
                        }
                      }
                      return event.target.value;
                    }
                  }
                }),
                h('a', {
                  style: {
                    marginLeft: '5px',
                  },
                  on: {
                    click: () => {
                      if (adjust_num == '') return $fcError(t('请输入调整的库存数量'))
                      let content = t('是否确定调整库存？')
                      if (btn.confirm && JSON.parse(btn.confirm) && JSON.parse(btn.confirm).desc) {
                        content = JSON.parse(btn.confirm).desc
                      }
                      $fcWarn({
                        className: 'ark-dialog',
                        title: t('提示'),
                        content,
                        mask: true,
                        showCancel: true,
                        onOk: () => {
                          const payload = {
                            id: params.row.ID.val,
                            adjust_num
                          }
                          this.service.common.publicUrlParams('/api/cs/sg/sgBSaStorage/adjust', payload).then(res => {
                            if (res.data.code == 0) {
                              this.$Message.success(res.data.message)
                              $('#search')[0].click()
                            }
                          })
                        }
                      })
                    }
                  },
                }, btn.webdesc)
              ])
            }
          }
        }
        // 调拨入库分货 - 列表- 是否允许分货 & 操作
        if (this.tableName == 'SG_B_STO_TRANSFER_IN_DISTRIBUTION') {
          if (cellData.colname === 'IS_ALLOW_DISTRIBUTION') {
            render.renderContainer = 'CellRenderByFunction';
            render.renderComponent = (h, params) => {
              const name = params.row.IS_ALLOW_DISTRIBUTION.val
              return h('div', {}, [
                h('i-switch', {
                  props: {
                    value: params.value == t('是')
                  },
                  on: {
                    'on-change': (val) => {
                      const payload = { id: params.row.ID.val, is_allow_distribution: Number(val) }
                      this.service.common.publicUrlParams('/api/cs/sg/sgBStoTransferInDistribution/update', payload).then(res => {
                        if (res.data.code == 0) {
                          this.$Message.success(res.data.message)
                          $('#search')[0].click()
                        }
                      })
                    }
                  }
                }, [
                  h('span', { slot: 'open' }, t('是')),
                  h('span', { slot: 'close' }, t('否')),
                ])
              ])
            }
          }
          if (cellData.colId === 'ISACTIVE') {
            render.renderContainer = 'CellRenderByFunction';
            render.renderComponent = (h, params) => {
              let btn = []
              if (params.row.IS_ALLOW_DISTRIBUTION.val == t('是') && params.row.DISTRIBUTION_STATUS.val == t('未分货')) {
                btn.push(h('a', {
                  style: {
                    marginLeft: '5px',
                  },
                  on: {
                    click: () => {
                      this.EXECUTE_DISTRIBUTION({webdesc: t('立即分货')}, params.row)
                    }
                  },
                }, t('立即分货')))
              }
              return h('div', {}, btn)
            }
          }
        }
        // 商品SN码查询 - 列表 - SN码 - 点击右边滑出【SN码流水】
        if (this.tableName == 'SG_C_PRO_SN' && cellData.colname === 'ECODE') {
          if (true) {
            render.renderContainer = 'CellRenderByFunction';
            render.renderComponent = (h, params) => {
              const name = params.row.ECODE.val
              return h('div', [
                h('i', {
                  style: {
                    fontSize: '12px',
                    color: '#0f8ee9',
                    cursor: 'pointer',
                  },
                  on: {
                    click: () => {
                      vm.$store.commit("omsStore/up_snCodeDrawer", params.row);
                      Vue.component('SG_C_PRO_SN', () => import('@/config/minxin/standardTable/list/SG_C_PRO_SN.vue'));
                      vm.$store.commit("omsStore/up_listOtherComponent", 'SG_C_PRO_SN');
                    },
                  },
                }, `${name}`),
              ]);
            }
          }
        }
        // 订单旗帜档案 - 列表 - 旗帜颜色
        if (this.tableName == 'OC_B_ORDER_FLAG' && cellData.colname === 'FLAG_COLOR') {
          render.renderContainer = 'CellRenderByFunction';
          render.renderComponent = (h, params) => {
            let color = 'red'
            try {
              const colorArr = this.$refs.R3listform.ItemLists.FLAG_COLOR.combobox
              color = colorArr.find(i => i.limitdesc == params.row.params).limitval
            } catch (e) {
              console.error(e)
            }
            return h('div', {
              style: {
                'text-align': 'center'
              }
            }, [
              h('i', {
                class: 'iconfont icon icon-flag-black',
                style: {
                  fontSize: '23px',
                  color,
                  cursor: 'pointer',
                }
              })
            ])
          };
        }
      }
      // 物流交接单 - 操作
      if (this.tableName === 'SG_B_LOGISTICS_DELIVERY_ORDER') {
        if (cellData.colId === 'ISACTIVE') {
          render.renderContainer = 'CellRenderByFunction';
          render.renderComponent = (h, params) => {
            let btn = []
            const { BILL_STATUS, ID } = params.row
            if (BILL_STATUS.val == t("待交接")) {
              const fn = function (type) {
                $fcWarn({
                  className: 'ark-dialog',
                  title: t('提示'),
                  content: `${t('是否确认执行')}【${type == 1 ? t('完成') : t('取消')}】？`,
                  mask: true,
                  showCancel: true,
                  onOk: () => {
                    // vm.$R3loading.show(vm.loadingName);
                    vm.service.common.publicUrlParams('/api/cs/sg/v1/logisticsDelivery/handover', { id: ID.val, billStatus: type }).then(res => {
                      if (res.data.code == 0) {
                        vm.$Message.success(res.data.message);
                        $('.R3-buttonList #refresh')[0].click()
                      }
                    }).finally(e => {
                      // vm.$R3loading.hide(vm.loadingName);
                    })
                  }
                })
              }
              btn.push(h('a', {
                style: {
                  marginLeft: '5px',
                },
                on: {
                  click: () => {
                    fn(1)
                  }
                },
              }, t('完成')))
              btn.push(h('a', {
                style: {
                  marginLeft: '16px',
                  color: '#ff0000'
                },
                on: {
                  click: () => {
                    fn(2)
                  }
                },
              }, t('取消')))
            }
            return h('div', {}, btn)
          }
        }
      }
      // 库存中心/SN码管理/商品SN码查询 - 编码 - 点击更新右边的小表
      if (this.tableName === 'PS_C_PRO_SN') {
        if (cellData.colId === 'PS_C_PRO_ECODE') {
          render.renderContainer = 'CellRenderByFunction'; // 表示用组件方式渲染
          render.renderComponent = (h, params) => {
            return h('div', {
              style: {
                fontSize: '12px',
                color: params.row.PS_C_PRO_ECODE.val ? '#0f8ee9' : '#d1d1d1',
                cursor: 'pointer',
              },
              on: {
                click: () => {
                  const arr = JSON.parse(params.row.JSON_DATA.val)
                  vm.$store.commit("omsStore/up_PS_C_PRO_SN_CUSTOM_TABLE_DATA", arr);
                },
              },
            },
            `${params.row.PS_C_PRO_ECODE.val}`)
          };
        }
      }
      // 缺货商品明细-单据编号-点击跳转到零售详情
      if (this.tableName === 'V_RPT_OUTSTOCK_PRO_ITEM') {
        if (cellData.colId === 'BILL_NO') {
          render.renderContainer = 'CellRenderByFunction'; // 表示用组件方式渲染
          render.renderComponent = (h, params) => {
            return h('div', [
              h(
                'i',
                {
                  class: 'iconfont iconbj_link',
                  style: {
                    fontSize: '12px',
                    color: params.row.ORDER_ID.val ? '#0f8ee9' : '#d1d1d1',
                    cursor: 'pointer',
                    marginRight: '2px',
                  },
                  on: {
                    click: () => {
                      R3.store.commit('global/tabOpen', {
                        type: 'C',
                        customizedModuleName: 'orderManageDetail',
                        customizedModuleId: params.row.ORDER_ID.val,
                        label: t('零售发货单详情'),
                      });
                    },
                  },
                },
                `  ${params.row.BILL_NO.val}`
              ),
            ]);
          };
        }
        if (cellData.colId === 'CP_C_SHOP_ID') {
          // 店铺名称-不要渲染链接
          render.renderContainer = 'CellRenderByFunction';
          render.renderComponent = (h, params) => {
            return h('div', {}, params.row.CP_C_SHOP_ID.val);
          };
        }
      }
      if (this.tableName === 'V_SG_B_STO_MULTI_CHANNEL_TRANSFER_QUERY_RESULT') {
        if (cellData.colId === 'BILL_NO') {
          render.renderContainer = 'CellRender'; // 表示用组件方式渲染
          render.renderComponent = require('allpages/inventoryCenter/multiChannelTransferResult/iconLink').default;
        }
      }
      /* 这是另一种写法
       if (this.tableName === 'V_SG_B_STO_MULTI_CHANNEL_TRANSFER_QUERY_RESULT') {
         // 多渠道调拨结果查询
         if (cellData.colId === 'BILL_NO') {
           render.renderContainer = 'CellRenderByFunction'; // 表示用组件方式渲染
           render.renderComponent = (h, params) createElement=> {
             return h('div', [
               h('i', {
                 class: 'iconfont iconbj_link',
                 style: {
                   fontSize: '12px',
                   color: '#0f8ee9',
                   cursor: 'pointer',
                 },
                 on: {
                   click: () => {

                   },
                 },
               }),
               params.row.BILL_NO.val,
             ]);
           };
         }
       }*/
    },
    // 处理ag表格列数据
    R3_processColumns(columns) {
      return this.R3ProcessColumnsFun(columns);
    },
    // 查询按钮 - 列表界面查询按钮前置事件，可通过该事件改变查询接口参数
    R3_searchBefore(obj) {
      // this.searchData.isfresh = true;
      obj.callBack().then(() => {
        // delete this.searchData.isfresh; // 执行完要删除
      });
    },
    /**
     * 异常预警 - 查询添加入参
     */
    addReturnOrderWarningParams(data) {
      // 异常预警
      if (this.tableName === 'OC_B_RETURN_ORDER_WARNING') {
        if (this.$children[0].$children[1].$children[0]) {
          data.fixedcolumns.WARNING_TYPE = this.$children[0].$children[1].$children[0].warningType;
        }
        // const $_live_getChildComponent = this.$_live_getChildComponent(window.vm, 'returnOrderWarning'); // 获取组件实列
        // data.fixedcolumns.WARNING_TYPE = $_live_getChildComponent.warningType;
      }
      // 发票单管理
      // if (this.tableName === 'AC_F_ORDER_INVOICE') {
      //   const $_live_getChildComponent = this.$_live_getChildComponent(window.vm, 'orderInvoice'); // 获取组件实列
      //   if($_live_getChildComponent.searchName) {
      //     data.fixedcolumns[$_live_getChildComponent.searchName] = $_live_getChildComponent.auditStatus;
      //   }
      // }
    },
    /**
     * 处理ag表格列数据
     * @param columns
     * @constructor
     */
    R3ProcessColumnsFun(columns) {
      let result = [];
      // 不展示'订单ID'列，但要用这个ID来跳转，所以元数据不能去掉
      if (this.tableName === 'V_RPT_OUTSTOCK_PRO_ITEM') {
        result = columns.filter((i) => i.colname != 'ORDER_ID');
      }
      // 异常预警-表格数据处理
      if (this.tableName === 'OC_B_RETURN_ORDER_WARNING') {
        const $_live_getChildComponent = this.$_live_getChildComponent(window.vm, 'returnOrderWarning'); // 获取组件实列
        const columnKeyArr = configModule.processColumnsConfig.OC_B_RETURN_ORDER_WARNING;
        const data = [];
        const currData = columnKeyArr[$_live_getChildComponent.warningType] || [];
        columns.forEach((item) => {
          if (currData.includes(item.colname)) {
            // 判断是否为需要操作的表
            data.push(item);
          }
        });
        result = data;
      }

      // 多渠道调拨单查询-表格数据处理
      if (this.tableName === 'V_SG_B_STO_MULTI_CHANNEL_TRANSFER_QUERY_RESULT') {
        const data = [];
        columns.forEach((item) => {
          if (item.colname !== 'BILL_TYPE') {
            // 判断是否为需要操作的表
            data.push(item);
          }
        });
        result = data;
      }

      return result.length ? result : columns;
    },

    /**
     * 处理ag表格配置项
     * @param options
     * @returns {*}
     * @constructor
     */
    R3_processAgOptions(options) {
      options.rowHeight = this.$store.state.customize.baseHeight; // 设置表格行高
      options.headerHeight = this.$store.state.customize.baseHeight - 2; // 设置表头的高度
      return options;
    },
  },
});
